(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size' || this.stickyType === 'floating';
      this.isFloating = this.stickyType === 'floating';
      this.headerBounds = {};

      /* W-E (05·D-fuite) : un seul AbortController pour TOUTES les écoutes, y
         compris celle de matchMedia — `.bind()` créait une fonction neuve que
         `disconnectedCallback` ne pouvait pas retirer, et chaque re-rendu de la
         section en éditeur empilait une écoute retenant un noeud détaché. */
      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', () => this.setHeaderHeight(), { signal });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp, { signal });
      window.addEventListener('scroll', this.onScrollHandler, { signal, passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    createObserver() {
      this.observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.isFloating) this.header.classList.add('tr-header-floating--active');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.isFloating) this.header.classList.add('tr-header-floating--active');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.isFloating) this.header.classList.remove('tr-header-floating--active');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Mega-menu à blocs (01·R1, K4) : chaque panneau [data-tr-mega-menu] est
     rendu masqué dans le header puis rattaché au <details> du lien de menu
     correspondant (match par HANDLE, jamais par index). Sans JS : le
     sous-menu linklist standard reste fonctionnel (progressive enhancement). */
  class TrMegaMenus extends HTMLElement {
    connectedCallback() {
      /* Attendre que la section soit complète (le nav suit dans le DOM). */
      requestAnimationFrame(() => this.attach());
    }

    attach() {
      const headerWrapper = this.closest('.header-wrapper');
      if (headerWrapper === null) return;

      const panels = this.querySelectorAll('[data-tr-mega-menu]');
      for (const panel of panels) {
        const handle = panel.dataset.linkHandle;
        if (handle === undefined || handle === '') continue;

        const details = headerWrapper.querySelector(
          `.header__inline-menu details[data-tr-handle="${CSS.escape(handle)}"]`
        );
        const content = details === null ? null : details.querySelector('.mega-menu__content');
        if (content === null) continue;

        content.classList.add('mega-menu__content--tr-blocks');
        content.replaceChildren(panel);
        panel.hidden = false;
      }
    }
  }

  if (customElements.get('tr-mega-menus') === undefined) {
    customElements.define('tr-mega-menus', TrMegaMenus);
  }

  /* Éditeur : sélectionner un panneau (ou un bloc enfant) ouvre son menu. */
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('details.mega-menu');
    if (details !== null) details.setAttribute('open', '');
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const details = event.target.closest('details.mega-menu');
    if (details !== null) details.removeAttribute('open');
  });

  /* Olfactions — le menu s'ouvre au SURVOL, pas au clic (débrief Rafik).
     <details> s'ouvre au clic par nature : on pilote donc `open` à la souris.
     Sur pointeur fin et grand écran uniquement — au doigt, le survol n'existe
     pas et le clic doit rester le mode d'ouverture.
     Le lien parent redevient cliquable : un clic navigue vers sa page, comme
     demandé (« PARFUMS ouvre au survol ET reste cliquable »).
     Le clavier n'est pas touché : <summary> garde son comportement natif. */
  const trFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const trWideScreen = window.matchMedia('(min-width: 990px)');
  const trHoverActive = () => trFinePointer.matches && trWideScreen.matches;
  let trCloseTimer = null;

  const trBindHoverMenus = () => {
    const items = document.querySelectorAll('.header__inline-menu details');

    items.forEach((details) => {
      if (details.dataset.trHover === 'on') return;
      details.dataset.trHover = 'on';

      details.addEventListener('mouseenter', () => {
        if (!trHoverActive()) return;
        window.clearTimeout(trCloseTimer);
        items.forEach((other) => {
          if (other !== details) other.open = false;
        });
        details.open = true;
      });

      details.addEventListener('mouseleave', () => {
        if (!trHoverActive()) return;
        /* petit délai : la souris traverse un interstice entre le libellé
           et le panneau, sans quoi le menu se referme sous le curseur */
        trCloseTimer = window.setTimeout(() => {
          details.open = false;
        }, 140);
      });

      const summary = details.querySelector('summary');
      if (summary === null) return;

      summary.addEventListener('click', (event) => {
        if (!trHoverActive()) return;
        const url = details.dataset.trUrl;
        event.preventDefault();
        if (url && url !== '#') window.location.href = url;
      });
    });
  };

  /* Le bundle de section peut s'exécuter avant que le menu soit dans la page :
     on attend le DOM si nécessaire, sinon rien n'est branché et le survol
     reste sans effet. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trBindHoverMenus);
  } else {
    trBindHoverMenus();
  }
  document.addEventListener('shopify:section:load', trBindHoverMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-panorama"] && !Shopify.designMode) return;
  try {
    
  class TrPanorama extends HTMLElement {
    #rail = null;
    #next = null;
    #progress = null;
    #progressBar = null;
    #controller = null;
    #observer = null;

    connectedCallback() {
      this.#rail = this.querySelector('[data-ref="panoramaRail"]');
      if (this.#rail === null) return;

      this.#next = this.querySelector('[data-ref="panoramaNext"]');
      this.#progress = this.querySelector('[data-ref="panoramaProgress"]');
      this.#progressBar = this.querySelector('[data-ref="panoramaProgressBar"]');
      if (this.#next === null && this.#progressBar === null) return;

      this.#controller = new AbortController();
      const { signal } = this.#controller;

      if (this.#next !== null) {
        this.#next.hidden = false;
        this.#next.addEventListener('click', () => {
          const panel = this.#rail.querySelector('.tr-collage-item');
          const step = panel === null ? this.#rail.clientWidth : panel.getBoundingClientRect().width;
          this.#rail.scrollBy({ left: step, behavior: 'smooth' });
        }, { signal });
      }

      this.#rail.addEventListener('scroll', this.#sync, { signal, passive: true });

      /* La largeur défilable change après coup : images décodées, fenêtre
         redimensionnée, panneaux ajoutés dans l'éditeur. */
      if (window.ResizeObserver !== undefined) {
        this.#observer = new ResizeObserver(this.#sync);
        this.#observer.observe(this.#rail);
      }

      this.#sync();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#observer?.disconnect();
    }

    #sync = () => {
      const { scrollWidth, clientWidth } = this.#rail;
      const position = Math.abs(this.#rail.scrollLeft);

      /* En bout de rail, la flèche s'efface — elle n'a plus rien à montrer. */
      if (this.#next !== null) {
        const end = position + clientWidth >= scrollWidth - 4;
        this.#next.style.opacity = end ? '0' : '1';
        this.#next.style.pointerEvents = end ? 'none' : 'auto';
      }

      /* Ligne : visible seulement si le rail déborde ; lue à chaque défilement
         pour suivre le doigt sans attendre l'arrêt. */
      if (this.#progressBar !== null) {
        const scrollable = scrollWidth > clientWidth + 1;
        this.#progress.hidden = scrollable === false;
        if (scrollable === false) return;

        const part = clientWidth / scrollWidth;
        const pos = position / scrollWidth;
        this.#progressBar.style.setProperty('--tr-panorama-progress-part', part.toFixed(4));
        this.#progressBar.style.setProperty('--tr-panorama-progress-pos', (pos / part).toFixed(4));
      }
    };
  }

  if (customElements.get('tr-panorama') === undefined) {
    customElements.define('tr-panorama', TrPanorama);
  }

  } catch(e) { console.error(e); }
})();
})();
